import { isRejectedWithValue } from '@reduxjs/toolkit'
import { toast } from 'react-hot-toast';
import { setRedirectUrl } from '../components/redirect/redirectSlice';

/**
 * show a toast on error!
 */
export const rtkQueryErrorLogger = ({getState, dispatch}) => (next) => (action) => {

  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (isRejectedWithValue(action)) {
    const { error } = action.payload.data
    toast.error(error?.message ?? `Unknown Error occurred`)
    
    if (error?.redirectUrl) {
      next(setRedirectUrl(error?.redirectUrl))
    }
  }
  
  return next(action)
}